export enum LANGUAGE_CODE {
  ZHHK = "zhHK",
  EN = "en"
}

export enum RECEIPT_STATUS {
  PENDING_PAYMENT = "PENDING_PAYMENT",
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
  CHECK_IN = "CHECK_IN",
  APPROACHING = "APPROACHING",
  ARRIVED = "ARRIVED",
  ON_GOING = "ON_GOING",
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  SUCCESS = "SUCCESS",
  SUCCESSFUL = "SUCCESSFUL",
  TIMED_OUT = "TIMED_OUT",
  FAILED = "FAILED",
  EXPIRED = "EXPIRED",
  // MOBILE_PAYMENT's own status enum (TxSoftposStatus) — distinct string from FAILED above.
  FAILURE = "FAILURE",
}

export enum PAYMENT_TX_PAYMENT_METHOD {
  VISA = "VISA",
  MASTERCARD = "MASTERCARD",
  MASTER = "MASTER",
  ALIPAY = "ALIPAY",
  WECHAT = "WECHAT",
  UNIONPAY = "UNIONPAY",
  DISCOVER = "DISCOVER",
  OCTOPUS = "OCTOPUS",
  GOOGLE_PAY = "GOOGLE_PAY",
  APPLE_PAY = "APPLE_PAY",
}

export type OrderStatus = "scheduled" | "enroute" | "intransit" | "completed" | "cancelled";